export default __webpack_public_path__ + "static/media/gallery-37.a4b66a6a.jpg";